import React from 'react';
import './MeasurementForm.css';

interface MeasurementNameInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const MeasurementNameInput: React.FC<MeasurementNameInputProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  return (
    <div className="form-group">
      <label htmlFor="name">Measurement Name <span className="required">*</span></label>
      <input
        type="text"
        id="name"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter measurement name"
        required
        disabled={disabled}
      />
    </div>
  );
};

export default MeasurementNameInput;
